import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { TokenStorageService } from '../../core/authentication/token-storage.service';

declare const Waves: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit, OnDestroy {
  user: any;
  public sidebarItems: any[];
  level1Menu = '';
  level2Menu = '';
  level3Menu = '';
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  headerHeight = 60;
  routerObj = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    // private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {
    this.user = this.tokenStorage.getUser();
    // this.routerObj = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     // logic for select active menu in dropdown
    //     const currenturl = event.url.split('?')[0];
    //     this.level1Menu = currenturl.split('/')[1];
    //     this.level2Menu = currenturl.split('/')[2];

    //     // close sidebar on mobile screen after menu select
    //     this.renderer.removeClass(this.document.body, 'overlay-open');
    //   }
    // });
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = (event.urlAfterRedirects || event.url).split('?')[0];

        // Mantener abierto el menú correcto según ROUTES
        this.syncMenuWithUrl(currentUrl);

        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  callLevel1Toggle(event: any, element: any) {
    if (element === this.level1Menu) {
      this.level1Menu = '0';
    } else {
      this.level1Menu = element;
    }
    const hasClass = event.target.classList.contains('toggled');
    if (hasClass) {
      this.renderer.removeClass(event.target, 'toggled');
    } else {
      this.renderer.addClass(event.target, 'toggled');
    }
  }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = '0';
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = '0';
    } else {
      this.level3Menu = element;
    }
  }
  ngOnInit() {
    if (this.tokenStorage.getUser) {
      this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    }
    // abre el menú correcto al entrar o recargar
    const currentUrl = this.router.url.split('?')[0];
    this.syncMenuWithUrl(currentUrl);

    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest('body');

    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest('body');

    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  private syncMenuWithUrl(url: string) {
    // Si quieres que se mantenga el último menú abierto aunque no coincida con la ruta,
    // comenta estos resets.
    this.level1Menu = '';
    this.level2Menu = '';
    this.level3Menu = '';

    for (const l1 of this.sidebarItems || []) {
      if (l1.groupTitle) continue;

      // nivel 1 sin submenu
      if (l1.path && this.isActive(url, l1.path)) {
        this.level1Menu = l1.moduleName;
        return;
      }

      // buscar en hijos
      if (l1.submenu?.length) {
        for (const l2 of l1.submenu) {
          if (l2.path && this.isActive(url, l2.path)) {
            this.level1Menu = l1.moduleName;
            this.level2Menu = l2.moduleName || l1.moduleName; // por si repites moduleName
            return;
          }

          // buscar en nietos (nivel 3)
          if (l2.submenu?.length) {
            for (const l3 of l2.submenu) {
              if (l3.path && this.isActive(url, l3.path)) {
                this.level1Menu = l1.moduleName;
                this.level2Menu = l2.moduleName || l1.moduleName;
                this.level3Menu = l3.moduleName || l2.moduleName;
                return;
              }
            }
          }
        }
      }
    }
  }

  private isActive(currentUrl: string, targetPath: string): boolean {
    // Normaliza doble slash si hubiera
    const cur = currentUrl.replace(/\/+$/, '');
    const tgt = targetPath.replace(/\/+$/, '');
    return cur === tgt || cur.startsWith(tgt + '/');
  }

}
